export type ShopTab = "Categories" | "Products" | "Orders";

export const SHOP_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "ACTIVE", label: "Active" },
  { value: "DISABLED", label: "Disabled" },
];

export const SHOP_ORDER_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "PLACED", label: "Placed" },
  { value: "CANCELLED", label: "Cancelled" },
];

export const formatShopMoney = (n: number) =>
  n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
